module.exports = __webpack_public_path__ + "pdf/PCG_TItle1SalesSheet_1.pdf";


//////////////////
// WEBPACK FOOTER
// ./pdf/PCG_TItle1SalesSheet_1.pdf
// module id = 238
// module chunks = 0